/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-15T11:07:06.866
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-RentHouseSalesCard-'

export default 
{
path: '/rentmanage/renthousesalescard',
name: 'rentmanage-RentHouseSalesCard',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}RentHouseSalesCard-index',

meta:{
...meta,
title: '卡券管理'
},

component: () => import('@/pages/rentmanage/renthousesalescard/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}RentHouseSalesCard-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '卡券管理编辑'
},

component: () => import('@/pages/rentmanage/renthousesalescard/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}RentHouseSalesCarddetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '卡券管理新增'
},

component: () => import('@/pages/rentmanage/renthousesalescard/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}RentHouseSalesCardView',
auth: [
'hidden'
],

meta:{
...meta,
title: '卡券管理详情查看'
},

component: () => import('@/pages/rentmanage/renthousesalescard/detail-view') ,
},
]
};
